import { getSearchParams } from '@wix/package-picker-shared';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { useEffect } from 'react';
import { useCurrentModule } from '../components';
import { resolveRecommendation } from './resolveRecommendation';
import { ECLIPSE_MOBILE_MODULE_NAME } from '../utils/moduleNames';
import { useAiRecommendationEnabled } from './useAiRecommendationEnabled';
import { useReportQueryError } from './useReportQueryError';
const QUERY_OPTIONS = {
  staleTime: Infinity,
  refetchOnWindowFocus: false,
  useErrorBoundary: false
};
export const useEclipsePlanRecommendation = () => {
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  const {
    isEnabled,
    showsGeneratedContent
  } = useAiRecommendationEnabled();
  // Mobile shows the tier pick only - no card - so showsGeneratedContent is false there and the
  // LLM bullets are never requested. The tier call still needs the surface itself.
  const isMobile = module.moduleName === ECLIPSE_MOBILE_MODULE_NAME;
  const {
    siteGuid,
    referralAdditionalInfo
  } = getSearchParams();
  const p3Context = PremiumPurchasePlatformModule.internals.useContext();
  const reportQueryError = useReportQueryError();
  const {
    data: tierData
  } = module.SDK.planRecommendationApiClient.hooks.useGetPlanRecommendationTier({
    siteGuid,
    p3Context,
    isMobile,
    referral: referralAdditionalInfo
  }, isEnabled, {
    ...QUERY_OPTIONS,
    onError: error => reportQueryError('getPlanRecommendationTier', error)
  });
  const {
    data: bulletsData,
    isLoading: isBulletsLoading,
    isError
  } = module.SDK.planRecommendationApiClient.hooks.useGetPlanRecommendation({
    siteGuid,
    p3Context,
    referral: referralAdditionalInfo
  }, showsGeneratedContent, {
    ...QUERY_OPTIONS,
    onError: error => reportQueryError('getPlanRecommendation', error)
  });
  const recommendedProductId = (tierData == null ? void 0 : tierData.recommendedProductId) ?? '';
  const recommendedProductName = (tierData == null ? void 0 : tierData.recommendedProductName) ?? '';
  const siteName = (tierData == null ? void 0 : tierData.siteName) ?? '';
  useEffect(() => {
    if (isEnabled && recommendedProductId) {
      module.SDK.aiRecommendationStore.setRecommendedProductId(recommendedProductId);
    }
  }, [isEnabled, recommendedProductId, module]);
  const resolvedBullets = resolveRecommendation({
    data: bulletsData,
    recommendedProductName,
    t
  });
  return {
    recommendedProductId,
    recommendedProductName,
    siteName,
    bullets: (resolvedBullets == null ? void 0 : resolvedBullets.bullets) ?? [],
    isBulletsLoading: showsGeneratedContent && isBulletsLoading,
    isError: showsGeneratedContent && isError,
    isEnabled,
    isFallback: (bulletsData == null ? void 0 : bulletsData.isFallback) ?? (tierData == null ? void 0 : tierData.isFallback) ?? false
  };
};
//# sourceMappingURL=useEclipsePlanRecommendation.js.map